import { Fragment, type JSX } from "react";

import { Box } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

type ConfigurationTreeCompletenessProps = {
  completed?: boolean;
  sx?: SxProps<Theme>;
};

export function CustomConfigurationTreeCompleteness(
  props: ConfigurationTreeCompletenessProps,
): JSX.Element {
  const { completed, sx } = props;

  const baseRectangleStyle: SxProps<Theme> = {
    width: 6,
    height: 20,
    ...sx,
  };

  return completed === true ? (
    <Box
      sx={{
        ...baseRectangleStyle,
        backgroundColor: "primary.main",
      }}
    />
  ) : completed === false ? (
    <Box
      sx={{
        ...baseRectangleStyle,
        backgroundColor: "warning.main",
      }}
    />
  ) : (
    <Fragment />
  );
}
